import { Component } from '@angular/core';

@Component({
  selector: 'mi-home-header',
  imports: [],
  templateUrl: './home-header.component.html',
  styleUrl: './home-header.component.scss',
})
export class HomeHeaderComponent {

}
